import AllInvoices from "./AllInvoices";
import InvoiceView from "./InvoiceView";
import "./styles.scss";

export default { AllInvoices, InvoiceView };
